import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { RootState } from '../../models/RootState';
import {
  addExchangeBet,
  getCurrencyTypeFromToken,
  addToMultiMarket,
  removeToMultiMarket,
  checkIncludeMultiMarket,
} from '../../store';
import './ExchBookmakerMarketTable.scss';
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  Tooltip,
  Drawer,
} from '@material-ui/core';
import { PlaceBetRequest } from '../../models/BsData';
import ExchOddBtn from '../ExchOddButton/ExchOddButton';
import { UserBet } from '../../models/UserBet';
import moment from 'moment';
import InfoImg from '../../assets/images/sportsbook/info.svg';
import {
  BookmakerDTO,
  BookmakerRunnerDTO,
} from '../../models/common/BookmakerDTO';
import { EventDTO } from '../../models/common/EventDTO';
import API from '../../api';
import Modal from '../../components/Modal/Modal';
import MarketTermsCondi from '../../components/MarketTermsCondi/MarketTermsCondi';
import { IonIcon, IonRow } from '@ionic/react';
import { CURRENCY_TYPE_FACTOR } from '../../constants/CurrencyTypeFactor';
import { TOSS_ODD_VALUE } from '../../constants/CommonConstants';
import { ThousandFormatter } from '../../util/stringUtil';
import StarBorderRoundedIcon from '@material-ui/icons/StarBorderRounded';
import StarIcon from '@material-ui/icons/Star';
import { useHistory } from 'react-router-dom';
import { useMarketLocalState } from '../../hooks/storageHook';
import multipin from '../../assets/images/common/multipin.svg';
import removemultipin from '../../assets/images/common/removemultimarket.svg';
import { CloseOutlined } from '@material-ui/icons';
import { isMobile } from 'react-device-detect';
import { useInterval } from '../../hooks/useInterval';
type StoreProps = {
  eventData: EventDTO;
  bmMData: BookmakerDTO[];
  bets: PlaceBetRequest[];
  openBets: UserBet[];
  commissionEnabled: boolean;
  addExchangeBet: (data: PlaceBetRequest) => void;
  loggedIn: boolean;
  getFormattedMinLimit: (num: number) => string;
  getFormattedMaxLimit: (num: number) => string;
  isMultiMarket?: boolean;
  exposureMap: any;
  fetchEvent: (
    sportId: string,
    competitionId: string,
    eventId: string,
    marketTime: string
  ) => void;
};

type OddsInfoMsg = {
  launch: boolean;
  oddsType: string;
  eventTypeID: string;
};

type LimitsType = Map<string, { minStake: number; maxStake: number }>;

const BmMTable: React.FC<StoreProps> = (props) => {
  const {
    eventData,
    bmMData,
    bets,
    openBets,
    commissionEnabled,
    addExchangeBet,
    isMultiMarket,
    loggedIn,
    exposureMap,
    fetchEvent,
  } = props;
  let history = useHistory();
  const [multiMarketData, setMultiMarketData] = useMarketLocalState();
  const [bmLimits, setBMLimits] = useState<any>({});
  const [infoDilalog, setInfoDialog] = useState<OddsInfoMsg>({
    launch: false,
    oddsType: null,
    eventTypeID: null,
  });
  const marketData = useMarketLocalState();
  const disabledStatus = [
    'suspended',
    'closed',
    'suspended-manually',
    'suspended manually',
    'ball_running',
    'ball running'
  ];

  const cFactor = CURRENCY_TYPE_FACTOR[getCurrencyTypeFromToken()];
  const tableFields = [
    {
      key: 'teamName',
      Label: 'Market',
      className: 'market-name-cell-head',
      align: 'left',
    },
    {
      key: 'Back',
      Label: 'Back',
      className: 'odds-cell-head back-odd',
      align: 'center',
    },
    {
      key: 'Lay',
      Label: 'Lay',
      className: 'odds-cell-head lay-odd',
      align: 'center',
    },
  ];

  const getOpenBetsPL = (runner: BookmakerRunnerDTO, marketId: string, marketName: string) => {

    if (exposureMap && exposureMap?.[`${marketId}:${marketName}`]) {
      for (let rn of exposureMap[`${marketId}:${marketName}`]) {
        if (rn.runnerId === runner.runnerId) {
          return rn?.userRisk / cFactor
        }
      }
    }
  };

  const getOpenBetsPLInArray = (
    runner: BookmakerRunnerDTO,
    marketId: string,
    marketName: string,
  ) => {
    let pl = getOpenBetsPL(runner, marketId, marketName);
    return pl ? [pl] : [];
  };

  const getTotalPL = (runner: BookmakerRunnerDTO, marketId: string, marketName: string) => {
    let returns = null;
    const mBetslipBets = bets.filter(
      (b) => b.marketId === marketId && b.amount && b.amount > 0
    );
    if (mBetslipBets.length > 0) {
      returns = getOpenBetsPL(runner, marketId, marketName);
      for (let bet of mBetslipBets) {
        const plVal = (bet.oddValue / 100 + 1) * bet.amount - bet.amount;
        if (bet.betType === 'BACK') {
          if (bet.outcomeId === runner.runnerId)
            returns ? (returns += plVal) : (returns = plVal);
          else returns ? (returns -= bet.amount) : (returns = 0 - bet.amount);
        } else if (bet.betType === 'LAY') {
          if (bet.outcomeId === runner.runnerId)
            returns ? (returns -= plVal) : (returns = 0 - plVal);
          else returns ? (returns += bet.amount) : (returns = bet.amount);
        }
      }
    }
    return [returns];
  };


  // useEffect(() => {
  //   if (bmMData && bmMData.length > 0) {
  //     for (let market of bmMData) {
  //       const interval = setInterval(() => {
  //         fetchBetLimits(market.marketId);
  //       }, 5000);
  //       return () => clearInterval(interval);
  //     }
  //   }
  // }, []);

  // const fetchBetLimits = async (marketId: string) => {
  //   try {
  //     const payload = {
  //       sportId: eventData.sportId,
  //       competitionId: eventData.competitionId,
  //       eventId: eventData.eventId,
  //       marketType: 'BOOKMAKER',
  //       marketId: marketId,
  //       outcomeDesc: 'fancy',
  //       sessionId: marketId,
  //       mcategory: "ALL",
  //     };
  //     let response;
  //     if (sessionStorage.getItem('jwt_token')) {
  //       response = await API.post('/bs/fetch-market-limits', payload, {
  //         headers: {
  //           Authorization: sessionStorage.getItem('jwt_token'),
  //         },
  //       });
  //     } else {
  //       response = await API.post('/bs/fetch-market-limits', payload);
  //     }
  //     if (response.status === 200 && response.data.success) {
  //       let limits = bmLimits;
  //       limits[marketId ? marketId : eventData.marketId] = {
  //         min: response.data.limits.minStake,
  //         max: response.data.limits.maxStake,
  //         oddLimt: response.data.limits.maxOdd,
  //       };
  //       // setBMLimits({ ...limits });
  //     }
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };

  const handleMultiMarket = (
    competitionId,
    eventId,
    marketId,
    providerName,
    sportId,
    isAdd = true
  ) => {
    if (loggedIn) {
      if (isAdd) {
        addToMultiMarket(
          competitionId,
          eventId,
          marketId,
          providerName,
          sportId
        );
        marketId &&
          setMultiMarketData((prevState) => {
            return [
              ...prevState,
              {
                competitionId,
                eventId,
                marketId,
                providerName,
                sportId,
              },
            ];
          });
      } else {
        removeToMultiMarket(eventId, marketId);
        marketId &&
          setMultiMarketData((prevState) => {
            let data = [...prevState];
            const index = data?.findIndex(
              (itm) => itm.eventId === eventId && itm.marketId === marketId
            );
            index > -1 && data.splice(index, 1);
            return [...data];
          });
      }
    } else {
      history.push('/login');
    }
  };

  return (
    <>
      {bmMData.map((market, index) => (
        <>
          {!isMultiMarket ||
            checkIncludeMultiMarket(
              multiMarketData,
              market.marketId,
              eventData.eventId
            ) ? (
            <>
              <div className="bm-table-ctn">
                <div className="bm-table-content table-ctn">
                  <TableContainer component={Paper}>
                    <Table className="bm-table">
                      <TableHead>
                        <TableRow>
                          <TableCell colSpan={3}>
                            <div className="market-name-cell-head-ctn">
                              <span className="market-name">
                                {!checkIncludeMultiMarket(
                                  multiMarketData,
                                  market.marketId,
                                  eventData?.eventId
                                ) ? (
                                  <Tooltip
                                    title="Add To Multi Markets "
                                    placement="left-start"
                                  >
                                    <img
                                      src={multipin}
                                      alt="multipin"
                                      className="multi-add-icon"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        multiMarketData?.length < 10 &&
                                          handleMultiMarket(
                                            eventData?.competitionId,
                                            eventData?.eventId,
                                            market.marketId,
                                            eventData?.providerName,
                                            eventData?.sportId,
                                            true
                                          );
                                      }}
                                    />
                                  </Tooltip>
                                ) : (
                                  <Tooltip
                                    title="Remove From Multi Markets"
                                    placement="left-start"
                                  >
                                    <img
                                      src={removemultipin}
                                      alt="multipin"
                                      className="multi-remove-icon"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleMultiMarket(
                                          eventData?.competitionId,
                                          eventData?.eventId,
                                          market.marketId,
                                          eventData?.providerName,
                                          eventData?.sportId,
                                          false
                                        );
                                      }}
                                    />
                                  </Tooltip>
                                )}{' '}
                                {market.marketName}{' '}
                                <span className="event-name">
                                  {isMultiMarket && !isMobile ? eventData?.eventName : null}
                                </span>
                                <IonIcon
                                  onClick={() =>
                                    setInfoDialog({
                                      launch: true,
                                      oddsType: 'Bookmaker',
                                      eventTypeID: eventData.sportId,
                                    })
                                  }
                                  className="info-img"
                                  src={InfoImg}
                                />
                                {market.commissionEnabled
                                  //  && commissionEnabled
                                  ? (
                                    <span className='blink-commission-bookmaker'>*</span>
                                  ) : null}
                                {/* <span className="no-commission">No Commission</span> */}
                              </span>
                              <span className='bet-limits-section web-view'>
                                MIN:
                                {ThousandFormatter(
                                  market?.marketLimits
                                    ? market?.marketLimits.minStake / cFactor
                                    : 100
                                )}{' '}
                                MAX:
                                {
                                  market?.marketLimits?.maxStake % 1000 === 0 ?
                                    ThousandFormatter(
                                      market?.marketLimits
                                        ? market?.marketLimits.maxStake / cFactor
                                        : 5000
                                    ) : market?.marketLimits
                                      ? market?.marketLimits.maxStake / cFactor
                                      : 5000
                                }
                                {/* {ThousandFormatter(
                                  market?.marketLimits
                                    ? market?.marketLimits.max / cFactor
                                    : 5000
                                )} */}
                              </span>
                              <span className='bet-limits-section mob-view'>
                                <div>
                                  MIN:
                                  {ThousandFormatter(
                                    market?.marketLimits
                                      ? market?.marketLimits.minStake / cFactor
                                      : 100
                                  )}{' '}
                                </div>
                                <div>
                                  MAX:
                                  {
                                    market?.marketLimits?.maxStake % 1000 === 0 ?
                                      ThousandFormatter(
                                        market?.marketLimits
                                          ? market?.marketLimits.maxStake / cFactor
                                          : 5000
                                      ) : market?.marketLimits
                                        ? market?.marketLimits.maxStake / cFactor
                                        : 5000
                                  }
                                </div>
                              </span>
                            </div>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow className="header-row">
                          {tableFields.map((tF, index) => (
                            <TableCell
                              key={tF.key + index}
                              align={tF.align === 'left' ? 'left' : 'center'}
                              className={tF.className}
                            >
                              {tF.key === 'lay' || 'back' ? (
                                <div className={tF.key.toLowerCase() + '-odd'}>
                                  {tF.Label}
                                </div>
                              ) : (
                                tF.Label
                              )}
                            </TableCell>
                          ))}
                        </TableRow>
                        {market ? (
                          <>
                            {market.runners.map((bmSelection, index) => (
                              <TableRow>
                                <TableCell className="team-name-cell">
                                  <div className="team">
                                    {bmSelection.runnerName}
                                    {getOpenBetsPLInArray(
                                      bmSelection,
                                      market.marketId,
                                      market.marketName
                                    ).map((ret) =>
                                      ret !== null ? (
                                        <span
                                          className={ret >= 0 ? 'profit' : 'loss'}
                                        >
                                          {ret > 0
                                            ? '+' + Number(ret).toFixed(2)
                                            : Number(ret).toFixed(2)}
                                        </span>
                                      ) : null
                                    )}
                                  </div>
                                  {bets.length > 0 && bets[0].amount > 0 ? (
                                    <div>
                                      {getTotalPL(
                                        bmSelection,
                                        market.marketId,
                                        market.marketName
                                      ).map((ret) =>
                                        ret !== null ? (
                                          <span
                                            className={
                                              ret >= 0 ? 'profit' : 'loss'
                                            }
                                          >
                                            {ret > 0
                                              ? '+' + Number(ret).toFixed(2)
                                              : Number(ret).toFixed(2)}
                                          </span>
                                        ) : null
                                      )}
                                    </div>
                                  ) : null}
                                </TableCell>
                                <TableCell className="odds-cell">
                                  <div className="odds-block">
                                    <ExchOddBtn
                                      mainValue={
                                        disabledStatus.includes(
                                          market.status?.toLowerCase()
                                        ) ||
                                          disabledStatus.includes(
                                            bmSelection.status?.toLowerCase()
                                          ) ||
                                            market.suspend === true
                                          ? 0
                                          : bmSelection.backPrice
                                      }
                                      subValue={Number(bmSelection.backSize)}
                                      oddType="back-odd"
                                      valueType="bookmakerOdds"
                                      showSubValueinKformat={true}
                                      disable={
                                        disabledStatus.includes(
                                          market.status?.toLowerCase()
                                        ) ||
                                        disabledStatus.includes(
                                          bmSelection.status?.toLowerCase()
                                        ) ||
                                          market.suspend === true
                                        ||
                                          moment(eventData.openDate).diff(
                                          moment(),
                                          'minutes'
                                        ) >
                                        60 * 24 * 2
                                      }
                                      onClick={() => {
                                        if (
                                          disabledStatus.includes(
                                            market.status?.toLowerCase()
                                          ) ||
                                          disabledStatus.includes(
                                            bmSelection.status?.toLowerCase()
                                          ) ||
                                            market.suspend === true
                                            ||
                                          moment(eventData.openDate).diff(
                                            moment(),
                                            'minutes'
                                          ) >
                                          60 * 24 * 2
                                        ) {
                                          return;
                                        }
                                        const betData: PlaceBetRequest = {
                                          sportId: eventData.sportId,
                                          seriesId: eventData.competitionId,
                                          seriesName: eventData.competitionName,
                                          eventId: eventData.eventId,
                                          eventName: eventData.eventName,
                                          eventDate: eventData.openDate,
                                          marketId: market.marketId,
                                          marketName: market.marketName,
                                          marketType: 'BM',
                                          outcomeId: bmSelection.runnerId,
                                          outcomeDesc: bmSelection.runnerName,
                                          betType: 'BACK',
                                          amount: 0,
                                          oddValue: Number(bmSelection.backPrice),
                                          sessionPrice: -1,
                                          oddLimt:
                                          market?.marketLimits?.maxOdd.toString(),
                                          minStake:
                                          market?.marketLimits?.minStake,
                                          maxStake:
                                          market?.marketLimits?.maxStake,
                                          mcategory: "ALL",
                                        };
                                        if (
                                          market.marketName.toUpperCase() ===
                                          'TOSS' &&
                                          Number(bmSelection.backPrice) > 0
                                        ) {
                                          betData['displayOddValue'] =
                                            TOSS_ODD_VALUE;
                                        }
                                        addExchangeBet(betData);
                                      }}
                                    />
                                  </div>
                                </TableCell>
                                <TableCell className="odds-cell">
                                  <div className="odds-block">
                                    <ExchOddBtn
                                      mainValue={
                                        disabledStatus.includes(
                                          market.status?.toLowerCase()
                                        ) ||
                                          disabledStatus.includes(
                                            bmSelection.status?.toLowerCase()
                                          )
                                          ||
                                            market.suspend === true
                                          ? 0
                                          : bmSelection.layPrice
                                      }
                                      subValue={Number(bmSelection.laySize)}
                                      oddType="lay-odd"
                                      valueType="bookmakerOdds"
                                      showSubValueinKformat={true}
                                      disable={
                                        disabledStatus.includes(
                                          market.status?.toLowerCase()
                                        ) ||
                                        disabledStatus.includes(
                                          bmSelection.status?.toLowerCase()
                                        ) ||
                                            market.suspend === true
                                        ||
                                        moment(eventData.openDate).diff(
                                          moment(),
                                          'minutes'
                                        ) >
                                        60 * 24 * 2
                                      }
                                      onClick={() => {
                                        if (
                                          disabledStatus.includes(
                                            market.status?.toLowerCase()
                                          ) ||
                                          disabledStatus.includes(
                                            bmSelection.status?.toLowerCase()
                                          ) ||
                                          market.suspend === true
                                          ||
                                          moment(eventData.openDate).diff(
                                            moment(),
                                            'minutes'
                                          ) >
                                          60 * 24 * 2
                                        ) {
                                          return;
                                        }
                                        const betData: PlaceBetRequest = {
                                          sportId: eventData.sportId,
                                          seriesId: eventData.competitionId,
                                          seriesName: eventData.competitionName,
                                          eventId: eventData.eventId,
                                          eventName: eventData.eventName,
                                          eventDate: eventData.openDate,
                                          marketId: market.marketId,
                                          marketName: market.marketName,
                                          marketType: 'BM',
                                          outcomeId: bmSelection.runnerId,
                                          outcomeDesc: bmSelection.runnerName,
                                          betType: 'LAY',
                                          amount: 0,
                                          oddValue: Number(bmSelection.layPrice),
                                          sessionPrice: -1,
                                          oddLimt:
                                            market?.marketLimits?.maxOdd.toString(),
                                          minStake:
                                            market?.marketLimits?.minStake,
                                          maxStake:
                                            market?.marketLimits?.maxStake,
                                          mcategory: "ALL",
                                          };
                                        if (
                                          market.marketName.toUpperCase() ===
                                          'TOSS' &&
                                          Number(bmSelection.layPrice) > 0
                                        ) {
                                          betData['displayOddValue'] =
                                            TOSS_ODD_VALUE;
                                        }
                                        addExchangeBet(betData);
                                      }}
                                    />
                                  </div>
                                </TableCell>
                                {disabledStatus.includes(bmSelection.status?.toLowerCase()) ||
                                  market.suspend === true ? (
                                  <div className="disabled-odds-cell" key={'row-' + index + 'cell-5'}>
                                    {bmSelection.status?.toLowerCase().includes('suspended')
                                      || market.suspend === true
                                      ? 'SUSPENDED'
                                      : bmSelection.status?.toLowerCase().replace('_', ' ')}
                                  </div>
                                ) : null}
                              </TableRow>
                            ))}
                          </>
                        ) : (
                          <>
                            <TableRow>
                              <TableCell colSpan={3}>
                                <div className="bm-table-msg-text">
                                  No Bookmaker Markets for this event
                                </div>
                              </TableCell>
                            </TableRow>
                          </>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>

                  <Drawer
                    anchor={'right'}
                    open={infoDilalog.launch}
                    onClose={() =>
                      setInfoDialog({
                        launch: false,
                        oddsType: null,
                        eventTypeID: null,
                      })
                    }
                    className="light-bg-title game-rules-drawer web-view"
                    title="Rules"
                  // size="md"
                  >
                    <div className="game-rules-header">
                      <div className="game-rules-title">Game Rules</div>
                      <div className="game-rules-close cursor" onClick={() => setInfoDialog({
                        launch: false,
                        oddsType: null,
                        eventTypeID: null,
                      })}><CloseOutlined /></div>
                    </div>
                    <MarketTermsCondi
                      oddsType={infoDilalog.oddsType}
                      eventTypeID={infoDilalog.eventTypeID}
                    />
                  </Drawer>
                  <Drawer
                    anchor={'bottom'}
                    open={infoDilalog.launch}
                    onClose={() =>
                      setInfoDialog({
                        launch: false,
                        oddsType: null,
                        eventTypeID: null,
                      })
                    }
                    className="light-bg-title game-rules-drawer mob-view"
                    title="Rules"
                  // size="md"
                  >
                    <div className="game-rules-header">
                      <div className="game-rules-title">Game Rules</div>
                      <div className="game-rules-close cursor" onClick={() => setInfoDialog({
                        launch: false,
                        oddsType: null,
                        eventTypeID: null,
                      })}><CloseOutlined /></div>
                    </div>
                    <MarketTermsCondi
                      oddsType={infoDilalog.oddsType}
                      eventTypeID={infoDilalog.eventTypeID}
                    />
                  </Drawer>
                </div>
              </div>
              <IonRow className="eam-section-divider"></IonRow>
            </>
          ) : null}
        </>
      ))}
    </>
  );
};

const mapStateToProps = (state: RootState) => {
  const eventType = state.exchangeSports.selectedEventType;
  const competition = state.exchangeSports.selectedCompetition;
  const event = state.exchangeSports.selectedEvent;

  return {
    // eventData: getAllMarketsByEvent(
    //   state.exchangeSports.events,
    //   eventType.id,
    //   competition.id,
    //   event.id
    // ),
    // bmMData: getBookmakerMarketsByEvent(
    //   state.exchangeSports.secondaryMarketsMap,
    //   event.id
    // ),
    bets: state.exchBetslip.bets,
    openBets: state.exchBetslip.openBets,
    commissionEnabled: state.common.commissionEnabled,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    addExchangeBet: (data: PlaceBetRequest) => dispatch(addExchangeBet(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BmMTable);
